import {ClaimInternalStatusCd} from '../';
import {EnumHelper} from './enum-helper';

export class ClaimInternalStatusCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in ClaimInternalStatusCd ) {
      this._values.push(ClaimInternalStatusCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): ClaimInternalStatusCd {

    for ( const obj in ClaimInternalStatusCd ) {
      if (ClaimInternalStatusCd[obj] === value){
        return ClaimInternalStatusCd[obj] as ClaimInternalStatusCd;
      }
    }
  }
}

const ClaimInternalStatusCdHelper = new ClaimInternalStatusCdHelperEnumHelperClass();
export default ClaimInternalStatusCdHelper;
